<div class="template1" *ngIf="footerData && contenthtml">
    <div class="z-index" [innerHTML]="contenthtml | safeHtml" appDynamicNavigation (isNavClicked)="navigateToRoute($event)"></div>
</div>
<div *ngIf="translateParams" class="text-center error-guid">
    {{'header.Error Occured while process your request. Please contact customer service with ID: ||errorGuid||' | translate | translateKey:translateParams}}
</div>
